"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var WrapperHelper =
/** @class */
function () {
  function WrapperHelper() {}

  WrapperHelper.mapTree = function (tree, is10, isLogin, isFk) {
    var classes = [];
    classes = tree["class"] ? tree["class"].split(" ").filter(function (x) {
      return !!x;
    }) : [];
    var result = {
      href: tree.url,
      targetValue: tree.id,
      label: tree.text,
      newColumn: tree.newColumn,
      noMobile: tree.noMobile,
      children: tree.children && tree.children.map(function (child) {
        return WrapperHelper.mapTree(child, is10, isLogin, isFk);
      })
    };

    if (tree.params) {
      result.href += tree.params;
    }

    switch (tree.target) {
      case "window":
        var params_1 = tree.targetParams.split(",");

        result.onClick = function () {
          return window.open(result.href, tree.id, "height=" + params_1[0] + ", width=" + params_1[1]);
        };

        break;

      case "_blank":
        result.target = "coba";
        break;

      default:
        break;
    }

    if (classes.includes("u-no-mobile")) {
      result.noMobile = true;
    } // explicitly check for false (undefined should be the same as true)


    var hasProtectedIcon = tree["public"] === false && !isLogin && !classes.includes("noSecureIcon");

    if (isFk && isLogin) {
      // explicitly check for false (undefined should be the same as true)
      hasProtectedIcon = tree.hasPermission === false;
    }

    if (classes.includes("iconTiles")) {
      result.isTileGroup = true;
    }

    if (classes.includes("tl-01")) {
      result.tileSize = 1;
    }

    if (classes.includes("tl-02")) {
      result.tileSize = 2;
    }

    if (classes.includes("toggleArea")) {
      result.hideMenuItem = true;
    }

    var iconClasses = classes.filter(function (x) {
      return x.startsWith("i-");
    });

    if (iconClasses.length) {
      result.iconName = iconClasses[0].replace("-", "_");
    } // Component specific changes


    if (is10) {
      result.label = React.createElement(React.Fragment, null, result.iconName && React.createElement(Icon_1.Icon, {
        name: result.iconName
      }), hasProtectedIcon && React.createElement(Icon_1.Icon, {
        className: "lsg--icon-protectedIcon",
        name: Icon_1.Icon.Names.object___lock
      }), result.label, tree.isNew ? React.createElement("span", {
        className: CSSPrefix_1.lsgPre + "header10b-new"
      }, "neu") : undefined);
      delete result.iconName; // tslint:disable-next-line:no-collapsible-if
    } else {
      if (hasProtectedIcon) {
        result.iconName = result.iconName || Icon_1.Icon.Names.object___lock;
      }
    }

    return result;
  };

  WrapperHelper.getSingleData = function (dataField) {
    var lsgAppData = null;

    try {
      lsgAppData = JSON.parse(document.getElementById(dataField).innerText);
    } catch (_a) {
      // tslint:disable-next-line:no-console
      console.log("Can't read " + dataField);
    }

    return lsgAppData;
  };

  WrapperHelper.getData = function () {
    var applicationData = WrapperHelper.getSingleData("applicationData");
    var resourceBundleData = WrapperHelper.getSingleData("resourceBundleData");
    var frameworkData = WrapperHelper.getSingleData("frameworkData");
    var navigationData = WrapperHelper.getSingleData("navigationData");
    var contentIncludesData = WrapperHelper.getSingleData("contentIncludesData");
    return {
      navigationData: navigationData,
      applicationData: applicationData,
      resourceBundleData: resourceBundleData,
      frameworkData: frameworkData,
      contentIncludesData: contentIncludesData
    };
  };

  return WrapperHelper;
}();

exports.WrapperHelper = WrapperHelper;